import { FluxStatusDtoFluxEnum } from 'lib_api/lib/api/gen';

export enum FluxType {
  RPSI = 'RPSI',
  ALIENATION_ETAT_BIENS = 'ALIENATION_ETAT_BIENS',
  ALIENATION_FOURRIERE = 'ALIENATION_FOURRIERE',
  ALIENATION_AUTORITE_FOURRIERE = 'ALIENATION_AUTORITE_FOURRIERE',
  ANTAI = 'ANTAI',
}

export const fluxTypeFromFluxStatusDto = (
  fluxType: FluxStatusDtoFluxEnum,
): FluxType => {
  switch (fluxType) {
    case FluxStatusDtoFluxEnum.RPSI:
      return FluxType.RPSI;
    case FluxStatusDtoFluxEnum.ALIENATION_ETAT_BIENS:
      return FluxType.ALIENATION_ETAT_BIENS;
    case FluxStatusDtoFluxEnum.ALIENATION_FOURRIERE:
      return FluxType.ALIENATION_FOURRIERE;
    case FluxStatusDtoFluxEnum.ALIENATION_AUTORITE:
      return FluxType.ALIENATION_AUTORITE_FOURRIERE;
    case FluxStatusDtoFluxEnum.ANTAI:
      return FluxType.ANTAI;
    default:
      throw new Error(`Unknown flux type: ${String(fluxType)}`);
  }
};
